module.exports = __webpack_public_path__ + "images/b0690e66a838b166118e9188b5d7bdfc-ATTA Logo 1000px.png";